/**
 * 定義系統中使用的所有類別及其對應顏色
 * 此文件用於統一管理類別的顏色
 */

// 預定義類別對應的顏色
export const CATEGORY_COLORS = {
  category_general: 'hsla(210, 70%, 50%, 0.85)',
  category_operation: 'hsla(210, 70%, 50%, 0.85)',  // 營運 - 藍色 (對應 blue)
  category_gaming: 'hsla(45, 70%, 50%, 0.85)',      // 遊戲 - 黃色 (對應 yellow)
  category_promo: 'hsla(350, 70%, 70%, 0.85)',      // 活動 - 粉紅色 (對應 pink)
  category_trans: 'hsla(180, 50%, 40%, 0.85)',      // 交易 - 青綠色 (對應 teal)
  category_member: 'hsla(200, 70%, 50%, 0.85)',     // 會員 - 藍色 (對應 blue)
  category_network: 'hsla(150, 70%, 45%, 0.85)',      // 網路 - 綠松石色 (對應 turquoise)
};

// 獲取類別列表
export const getCategoryList = () => {
  return Object.keys(CATEGORY_COLORS);
};

// 獲取類別顏色
export const getCategoryColor = (category) => {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS.category_general; // 默認使用藍色
};

export default {
  CATEGORY_COLORS,
  getCategoryList,
  getCategoryColor,
};
